import { Step, StepValidationState } from "../../../../../interfaces/step";
import { AssetSearchCriteriaComponent } from "projects/reg-hub-client/src/app/orders/asset-search-criteria/asset-search-criteria.component";
import { AssetSearchReviewComponent } from "projects/reg-hub-client/src/app/orders/asset-search-review/asset-search-review.component";
import { SearchStepper, eCriteriaVariation } from "../search-stepper";

export class ONAssetSearchStepper extends SearchStepper {
    constructor() {
        super();

        this.configuration = [
            eCriteriaVariation.SearchFromDate,
            eCriteriaVariation.ExactSimilar
        ];

        this.steps = [
            { title: "Search Criteria", content: AssetSearchCriteriaComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: AssetSearchReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}